// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"87":"5a09f1d955ff64d0a60d","123":"07e3b394a8bad44a29f2","207":"fe4382cda0e81dd9d7ea","324":"6f30687f17d50c6e04e0","556":"263c1b56cd7c781ee86a","923":"c7a3ca1bfaab2d2260a0"}[chunkId] + ".bundle.js";
};